"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentTheme = getCurrentTheme;
exports.getCurrentLevel = getCurrentLevel;
function getCurrentTheme() {
  //!!only one theme for one page
  var container = document && document.getElementsByClassName("a-theme-container");
  if (container && container[0]) {
    return container[0].getAttribute("theme") || "";
  }
  return "";
}

function getCurrentLevel() {
  //!!only one theme for one page
  var container = document && document.getElementsByClassName("a-theme-container");
  if (container && container[0]) {
    return container[0].getAttribute("level") || "";
  }
  return "";
}